import type { AxiosResponse } from 'axios';

type Method = 'GET' | 'POST' | 'PUT' | 'DELETE';

export interface HttpInterface {
  getServiceUrl(): string;
  send<Data, Params, Properties>(
    method: Method,
    url: string,
    data?: Data,
    headers?: object,
    params?: Params,
    properties?: Properties,
  ): Promise<AxiosResponse<unknown>>;
}

// TODO: replace console.error with logger
let sendInterface: HttpInterface['send'] = () => {
  throw new Error('initialize sendInterface with httpClientInterfaceInit first...');
};
let getServiceUrlInterface: HttpInterface['getServiceUrl'] = () => {
  throw new Error('initialize getServiceUrlInterface with httpClientInterfaceInit first...');
};

export const httpClientInterfaceInit = ({ send, getServiceUrl }: Partial<HttpInterface>) => {
  sendInterface = send || sendInterface;
  getServiceUrlInterface = getServiceUrl || getServiceUrlInterface;
};

export const send: HttpInterface['send'] = (...params) => sendInterface?.(...params);
export const getServiceUrl: HttpInterface['getServiceUrl'] = () => getServiceUrlInterface?.();
